module.exports = __webpack_public_path__ + "img/pen.5a8488d9.png";